export default {"src":"/_next/static/media/app-store.b66d30d2.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};